(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/app.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/app.js');
'use strict';

const _svs$app$ReactRouter = svs.app.ReactRouter,
  PlayerRouter = _svs$app$ReactRouter.PlayerRouter,
  Route = _svs$app$ReactRouter.Route;
const baseUrl = svs.core.data.baseUrl;
const ErrorBoundary = svs.components.errorBoundary.ErrorBoundary;
const routes = svs.myProfile.constants.routes;
const CommunicationSettings = svs.myProfile.react.pages.communicationSettings.CommunicationSettings;
const PlayerDetailsReduxProvider = svs.myProfile.react.store.PlayerDetailsReduxProvider;
const MyInformation = svs.myProfile.react.pages.myInformation.MyInformation;
const Notifications = svs.myProfile.react.pages.notifications.Notifications;
const _svs$myProfile$react$ = svs.myProfile.react.pages.kyc,
  Kyc = _svs$myProfile$react$.Kyc,
  KycQuestions = _svs$myProfile$react$.KycQuestions;
const PdItemsMenu = svs.myProfile.react.shared.components.PdItemsMenu;
const GridBase = svs.tb_ui_react.gridbase.GridBase;
const MyProfileApp = () => React.createElement(PlayerRouter, {
  basename: baseUrl,
  className: "bg-white",
  withRouter: true
}, React.createElement(ErrorBoundary, null, React.createElement(PlayerDetailsReduxProvider, null, React.createElement(PdItemsMenu, null), React.createElement(GridBase, {
  className: "f-left padding-1 main-content-constrained"
}, React.createElement(Route, {
  component: MyInformation,
  exact: true,
  path: routes.MY_PROFILE_HOME
}), React.createElement(Route, {
  component: MyInformation,
  exact: true,
  path: routes.MY_PROFILE_INFORMATION
}), React.createElement(Route, {
  exact: true,
  path: routes.MY_PROFILE_TRANSCRIPT,
  render: () => React.createElement(MyInformation, {
    isTranscriptLink: true
  })
}), React.createElement(Route, {
  exact: true,
  path: routes.MY_PROFILE_PLAYERDETAILS_CHANGE_EMAIL,
  render: () => React.createElement(MyInformation, {
    isChangeEmail: true
  })
}), React.createElement(Route, {
  exact: true,
  path: routes.MY_PROFILE_PLAYERDETAILS_MISSING_EMAIL,
  render: () => React.createElement(MyInformation, {
    isChangeEmail: true
  })
}), React.createElement(Route, {
  exact: true,
  path: routes.MY_PROFILE_PLAYERDETAILS_CONFIRM_EMAIL,
  render: () => React.createElement(MyInformation, {
    isChangeEmail: true
  })
}), React.createElement(Route, {
  exact: true,
  path: routes.MY_PROFILE_PLAYERDETAILS_CHANGE_MOBILE,
  render: () => React.createElement(MyInformation, {
    isChangeMobile: true
  })
}), React.createElement(Route, {
  exact: true,
  path: routes.MY_PROFILE_PLAYERDETAILS_CONFIRM_MOBILE,
  render: () => React.createElement(MyInformation, {
    isChangeMobile: true
  })
}), React.createElement(Route, {
  component: CommunicationSettings,
  exact: true,
  path: routes.MY_PROFILE_COMMUNICATION
}), React.createElement(Route, {
  exact: true,
  path: routes.MY_PROFILE_COMMUNICATION_ADAPT_CONTENT,
  render: () => React.createElement(CommunicationSettings, {
    isAdaptContent: true
  })
}), React.createElement(Route, {
  component: Notifications,
  exact: true,
  path: routes.MY_PROFILE_NOTIFICATIONS
}), React.createElement(Route, {
  component: Kyc,
  exact: true,
  path: routes.MY_PROFILE_KYC
}), React.createElement(Route, {
  component: KycQuestions,
  exact: true,
  path: routes.MY_PROFILE_KYC_QUESTIONS
})))));
svs.myProfile.MyProfileApp = MyProfileApp;

 })(window);